// extracted by mini-css-extract-plugin
module.exports = {"spacer":"style_spacer__ZYOwY"};